import { GlassCard } from "./GlassCard";

const StatusDot = ({ ok }) => (
  <span className="relative flex h-3 w-3">
    {ok && <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-white" />}
    <span
      className={`relative inline-flex h-3 w-3 rounded-full border ${
        ok ? "border-white bg-white" : "border-white/40 bg-transparent"
      }`}
    />
  </span>
);

export const StatusCard = ({ name, ok, detail, testId }) => (
  <GlassCard className="flex items-center justify-between p-6" hover={false}>
    <div className="flex items-center gap-4">
      <StatusDot ok={ok} />
      <div>
        <p className="font-display text-base font-semibold capitalize text-paper-100">{name}</p>
        {detail && <p className="text-xs text-paper-500">{detail}</p>}
      </div>
    </div>
    <span
      className={`rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-wider ${
        ok ? "border-white/25 text-paper-100" : "border-white/10 text-paper-500"
      }`}
      data-testid={testId}
    >
      {ok ? "Operational" : "Offline"}
    </span>
  </GlassCard>
);
